import { Input } from "@/components/ui/input";
import { Pill } from "@/lib/prim";
import { RANGE_KEYS } from "@/lib/download";

export default function RangeFilter({ value, onChange, prefix }) {
  const set = (patch) => onChange({ ...value, ...patch });
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${prefix}-range`}>
      {RANGE_KEYS.map(([k, l]) => <Pill key={k} active={value.range === k} onClick={() => set({ range: k })} testid={`${prefix}-range-${k}`}>{l}</Pill>)}
      {value.range === "custom" && (<>
        <Input type="date" className="h-8 w-40" value={value.start} onChange={(e) => set({ start: e.target.value })} data-testid={`${prefix}-start`} />
        <span className="text-slate-400">–</span>
        <Input type="date" className="h-8 w-40" value={value.end} onChange={(e) => set({ end: e.target.value })} data-testid={`${prefix}-end`} />
      </>)}
    </div>
  );
}

export const rangeParams = (v) => (v.range === "custom" ? (v.start && v.end ? { range: "custom", start: v.start, end: v.end } : null) : { range: v.range });
